var MDB = window.MDB || {};
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.ImprovementPoints = MDB.Mangl.ImprovementPoints || {};

(function($){
    var crudBaseUrl = document.location.origin + '/api/MANGL/ImprovementPoints/';

    $.extend(MDB.Mangl.ImprovementPoints, {
        boot: function () {
            MDB.Mangl.ImprovementPoints.createGrid('.improvementpoint-editor')
        },
        createGrid: function(selector){
            selector = $(selector);

            var categoryNames = {};
            var categoryDropdown = $('select[name="questionCategoryDropdown"]');
			
            categoryDropdown.find('option').each(function(){
                var $this = $(this);
                categoryNames[$this.attr('value')] = $this.text();
            });
            
            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function(opts){
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudBaseUrl + 'List', 'GET', opts);
                    },
                    create: function (opts) {
                        opts.error = function (res) { 
                            alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(res));
						 };

                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudBaseUrl + 'Create', 'POST', opts);
                    },
                    update: function(opts){
                        opts.error = function (res) { 
                            alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
						 };

                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudBaseUrl + 'Update', 'PUT', opts);
                    }
                },
                pageSize: 2000,
                schema: {
                    model: {
                        id: 'Id',
                        fields: {
                            Id: { editable: false, type: 'number' },
                            ShortDescription: {  },
                            Description: { },
                            QuestionCategoryId: { type: 'number' },
                            IsActive: {type: 'boolean'}
                        }
                    }
                }
            });

            var gridConfig = {
                dataSource: dataSource,
                toolbar: [{
                    text: MDB.loadResourceString('ImprovementPoints_Index_CreateButton_Text'),
                    name: 'create-popup',
                    iconClass: 'k-icon k-add'
                }],
                columns: [{
                    field: 'Id',
                    hidden: true,
                    hideOnEdit: true
                },{
                    field: 'QuestionCategoryId',
                    title: MDB.loadResourceString('ImprovementPointEditModel_QuestionCategoryId_DisplayName'),
                    width: '100px',
                    template: function(opts){
                        return categoryNames[opts.QuestionCategoryId];
                    },
                    editor: function (e, opts) {
                        var dropdown = MDB.KendoConfigBuilder.gridDropdownEditor(e, opts.field, categoryDropdown, undefined, opts);

                        //Sometimes a bug occurs causing the value to not be set during initialization of the component
                        if (opts.model.isNew()) {
                            opts.model[opts.field] = dropdown.val();
                        }
                    }
                }, {
                    field: 'ShortDescription',
                    title: MDB.loadResourceString('ImprovementPointEditModel_ShortDescription_DisplayName'),
                    width: '200px'
                }, {
                    field: 'Description',
                    title: MDB.loadResourceString('ImprovementPointEditModel_Description_DisplayName'),
                    width: '500px',
                    editor: function(e, opts){
                        MDB.KendoConfigBuilder.gridTextAreaEditor(e, opts.field, {
                            required: true,
                            validationMessage: MDB.loadResourceString('ImprovementPointModel_Description_RequiredMessage')
                        });
                    }
                }, {
                    field: 'IsActive',
                    title: MDB.loadResourceString('ImprovementPointEditModel_IsActive_DisplayName'),
                    width: '50px',
	                template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('IsActive')
                }, MDB.KendoConfigBuilder.gridCommandColumn([{
                    name: 'edit',
                    text: {
                        edit: MDB.loadResourceString('ImprovementPoints_Index_EditButton_Text'),
                        update: MDB.loadResourceString('ImprovementPoints_Index_UpdateButton_Text'),
                        cancel: MDB.loadResourceString('ImprovementPoints_Index_CancelButton_Text')
                    }
                }], '135px')],
		        messages: {
		            commands: MDB.KendoConfigBuilder.commandLabels(),
		            noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                edit: function(e){
                	if(kGrid.options.editable === 'popup'){
                        preparePopupEditor(e);
                	}
                },
		        pageable: true,
		        navigatable: true,
		        sortable: 'multipe',
		        scrollable: true,
		        editable: 'inline'
            }

            var kGrid = selector.kendoGrid(gridConfig).data('kendoGrid');

            //Toolbar option requires a non kendo 'default' name for this to work
            //Otherwise it will take kendo's default handler

            //https://stackoverflow.com/a/25470451/3697715
            selector.on('click', '.k-grid-create-popup', function(){
                var old = kGrid.options.editable;
			    kGrid.options.editable = 'popup';
			    kGrid.addRow();
			    kGrid.options.editable = old;
            });

            function preparePopupEditor(e){
                MDB.KendoConfigBuilder.hideColumnsOnEdit(e);
                var container = $(e.container)
                    , title = container.siblings().find('.k-window-title')
                    , form = container.find('.k-edit-form-container')
                    , buttons = container.find('.k-button');
				
                title.text(MDB.loadResourceString('ImprovementPoints_Index_CreateButton_Text'));

                container.width(800);
                form.width(container.width());

                buttons.css({
                    'position': 'relative',
                    'left': '-308px'
                });
            }
        }
    });
})(jQuery);